<template>
  <div id="app">
    <HeaderComp />
    <router-view />
    <FooterComp />
    <BotaoAltoContraste />
  </div>
</template>

<style lang="scss"> 
/*Fundo*/
.high-contrast body,
.high-contrast #app,
.high-contrast .container,
.high-contrast .menu,
.high-contrast .welcome-content {
  background-color: #000 !important;
  color: #fff !important;
}

/*itens do menu*/
.high-contrast .menu-list {
  background-color: #000 !important;
}
.high-contrast .menu-list li {
  background-color: #000 !important;
}
.high-contrast .menu-link {
  color: #fff !important;
  background-color: #000 !important;
}
.high-contrast .menu-link:hover {
  background-color: #222 !important;
  color: #fff !important;
}
.high-contrast .active .menu-link {
  background-color: #444 !important;
  color: #fff !important;
}

.high-contrast {
  background-color: #000 !important;
  color: #fff !important;
}

.high-contrast a,
.high-contrast button,
.high-contrast span,
.high-contrast h1,
.high-contrast h2,
.high-contrast h3,
.high-contrast h4,
.high-contrast h5,
.high-contrast h6,
.high-contrast p {
  color: #fff !important;
  background-color: #000 !important;
}

.high-contrast input,
.high-contrast textarea::placeholder {
  color: #bbb !important;
}
.high-contrast select {
  background-color: #000 !important;
  color: #fff !important;
}

.high-contrast .app-header {
  background-color: #000 !important;
}

.high-contrast .contrast-button {
  background-color: #000 !important;
  color: #fff !important;
}

.high-contrast .contrast-button:hover {
  background-color: #000 !important;
  color: #fff !important;
}

/*Nome da label*/
.high-contrast label {
  color: #fff !important;
}

/*Funda da label*/
.high-contrast input,
.high-contrast textarea,
.high-contrast select {
  background-color: #000 !important; 
  color: #fff !important;            
}

/*Texto dentro da label*/
.high-contrast input::placeholder,
.high-contrast textarea::placeholder {
  color: #fff !important; 
}
.high-contrast input:disabled {
  background-color: #000 !important; 
  color: #fff !important; 
}

.high-contrast .app-header {
  background-color: #000 !important;
  border-bottom: 2px solid #fff;
}

.high-contrast .btn-primary {
  border: 2px solid #fff !important; 
  color: #fff !important; 
  background-color: #000 !important; 
}
.high-contrast .btn-primary:hover {
  background-color: #222 !important; 
  border: 2px solid #fff !important;
}

/* Tabela */
.high-contrast th {
  background-color: #222 !important;
  color: #fff !important;
  border: 1px solid #fff !important;
}
.high-contrast tr {
  background-color: #000 !important;
  color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
.high-contrast td {
  background-color: #000 !important;
  color: #fff !important;
  border: 1px solid #fff !important;
  padding: 8px;
}
.high-contrast tr:nth-child(even) {
  background-color: #111 !important;
}
.high-contrast table a {
  color: #ff0 !important;
  text-decoration: underline;
}
.high-contrast table a:hover {
  color: #ffa500 !important;
}

/*Rodape */
.high-contrast footer {
  background-color: #000 !important;
  color: #fff !important;
  padding: 20px 0;
  text-align: center;
  border-top: 2px solid #fff !important;
}
.high-contrast footer a {
  color: #fff !important;
  text-decoration: underline;
}
.high-contrast footer a:hover {
  color: #ff0 !important;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; 
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

router-view {
  flex: 1; 
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<script>
import HeaderComp from '@/components/HeaderComp.vue';
import FooterComp from '@/components/FooterComp.vue';
import BotaoAltoContraste from './components/BotaoAltoContraste.vue';
export default {
  name: "ListaContatos",
  mounted() {
    document.title = "Lista de Contatos do TJPA";
  },
    components : {
      HeaderComp,
      FooterComp,
      BotaoAltoContraste
    },
  }
</script>